import { render, staticRenderFns } from "./pcTitle_logOnly.vue?vue&type=template&id=71bbc942&"
import script from "./pcTitle_logOnly.vue?vue&type=script&lang=js&"
export * from "./pcTitle_logOnly.vue?vue&type=script&lang=js&"
import style0 from "./pcTitle_logOnly.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports